module.exports = __webpack_public_path__ + "media/images/front/icons/top-113f6233291b8044cfd16e2f1b8d2544.png";